import { Session } from 'src_common/sdk/session';
import { AppEnvParamsBrowser } from 'src/utils/appEnvParams';
import {
    apiGetAutomationsRequest,
    ApiGetAutomationsResponseType,
} from 'src/api_openapi/v2/automations/apiGetAutomations';
import {
    ApiGetRunsParamsType,
    apiGetRunsRequest,
    ApiGetRunsResponseType,
} from 'src/api_openapi/v2/automations/apiGetRuns';
import {
    ApiCreateRunParamsType,
    apiCreateRunRequest,
    ApiCreateRunResponseType,
} from 'src/api_openapi/v2/automations/apiCreateRun';
import {
    ApiPatchAutomationFeedParamsType,
    apiPatchAutomationFeedRequest,
    ApiPatchAutomationFeedResponseType,
} from 'src/api_openapi/v2/automations/apiPatchAutomationFeed';

export class SdkAutotrader {
    public constructor(
        private readonly session: Session,
        private readonly envParamsBrowser: AppEnvParamsBrowser
    ) {}

    public getAutotraderAutomations(): Promise<ApiGetAutomationsResponseType> {
        return apiGetAutomationsRequest(
            `${this.envParamsBrowser.gatewayUrl}`,
            {},
            {
                traceparent: undefined,
                tracestate: undefined,
                authorization: `Bearer ${this.session.currentJwt}`,
            }
        );
    }

    public createAutotraderRun(params: ApiCreateRunParamsType): Promise<ApiCreateRunResponseType> {
        return apiCreateRunRequest(`${this.envParamsBrowser.gatewayUrl}`, params, {
            traceparent: undefined,
            tracestate: undefined,
            authorization: `Bearer ${this.session.currentJwt}`,
        });
    }

    public getAutotraderRuns(params: ApiGetRunsParamsType): Promise<ApiGetRunsResponseType> {
        return apiGetRunsRequest(`${this.envParamsBrowser.gatewayUrl}`, params, {
            traceparent: undefined,
            tracestate: undefined,
            authorization: `Bearer ${this.session.currentJwt}`,
        });
    }
    public patchAutoTraderAutomationFeed(
        params: ApiPatchAutomationFeedParamsType
    ): Promise<ApiPatchAutomationFeedResponseType> {
        return apiPatchAutomationFeedRequest(`${this.envParamsBrowser.gatewayUrl}`, params, {
            traceparent: undefined,
            tracestate: undefined,
            authorization: `Bearer ${this.session.currentJwt}`,
        });
    }
}
